import Layout from '@/components/layout/Layout';

const Terms = () => {
  return (
    <Layout>
      <section className="relative pt-8 pb-12 bg-background overflow-hidden min-h-screen">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-accent/5 blur-[120px] z-0" />

        <div className="container-max max-w-4xl relative z-10 px-4">
          <span className="inline-block px-4 py-2 bg-accent/5 border border-accent/20 rounded-full text-accent-foreground text-[10px] font-black uppercase tracking-[0.2em] mb-8">
            Agreement
          </span>
          <h1 className="text-2xl md:text-4xl font-black text-primary mb-12 tracking-tighter uppercase">Terms of <br /><span className="text-gradient-gold">Service</span></h1>

          <div className="card-premium !p-12 bg-white/40 border-white/60 backdrop-blur-xl">
            <div className="prose prose-lg max-w-none prose-headings:text-primary prose-headings:font-black prose-headings:uppercase prose-headings:tracking-tighter prose-p:text-muted-foreground prose-p:font-medium prose-p:leading-relaxed">
              <p className="text-sm font-black text-accent uppercase tracking-widest mb-12 pb-8 border-b border-gray-100">
                Last Updated: January 2024
              </p>

              <h2 className="text-2xl mb-6">Acceptance of Terms</h2>
              <p>
                By accessing and using the Ratchagan Analysis website and services, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use our services.
              </p>

              <h2 className="text-2xl mt-12 mb-6">Description of Services</h2>
              <p>
                Ratchagan Analysis provides stock market education through online courses, video content, live sessions, and community access. Our services are designed for educational purposes only.
              </p>

              <h2 className="text-2xl mt-12 mb-6">User Registration</h2>
              <p>
                To access certain features of our services, you may be required to register an account. You agree to provide accurate, current, and complete information during registration and to update such information as necessary.
              </p>

              <h2 className="text-2xl mt-12 mb-6">Course Access and Usage</h2>
              <ul className="list-none pl-0 space-y-4">
                <li className="flex gap-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                  <span>Course access is granted for the duration specified in your subscription plan.</span>
                </li>
                <li className="flex gap-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                  <span>You may not share, resell, or redistribute course content.</span>
                </li>
                <li className="flex gap-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                  <span>Recording or downloading course materials without permission is prohibited.</span>
                </li>
              </ul>

              <h2 className="text-2xl mt-12 mb-6">Payment Terms</h2>
              <ul className="list-none pl-0 space-y-4">
                <li className="flex gap-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                  <span>All prices are in Indian Rupees (INR) unless otherwise stated.</span>
                </li>
                <li className="flex gap-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 flex-shrink-0" />
                  <span>Payment is required at the time of enrollment.</span>
                </li>
              </ul>

              <h2 className="text-2xl mt-12 mb-6">Intellectual Property</h2>
              <p>
                All content on our platform, including but not limited to videos, articles, graphics, and course materials, is the intellectual property of Ratchagan Analysis and is protected by copyright laws.
              </p>

              <div className="mt-16 pt-12 border-t border-gray-100 italic">
                <p className="text-sm">
                  If you have any questions about these terms, please email us at{' '}
                  <a href="mailto:ratchagananalysis@gmail.com" className="text-accent font-bold hover:underline">
                    ratchagananalysis@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Terms;
